import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

/**
 * @description: This is intended to be used in internal admin, default query returns no deals
 * @author: Richard Scoones
 */
export const query = gql`
  query PerksHomepages($limit: Int, $cursor: String, $ids: [String!], $state: PerksHomepageActiveState) {
    perksHomepages(limit: $limit, cursor: $cursor, ids: $ids, state: $state) {
      results {
        uuid
        name
        bannerTagId
        birthdayTagId
        topCategoriesId
        lanes {
          type
          query {
            limit
            tagIds
            type
            sort
            ruleContexts
            q
          }
        }
      }
    }
  }
`

export const perksHomepageListNoDealsKey = getQueryNames(query)[0]

export default query
